import type { SymfonyRelation } from './SymfonyRelation'

/** Attribut kind used for editable form fields (fiche / edit). API returns also "I" for indicateurs. */
export const ATTRIBUT_KIND_EDITABLE = 'A'

/** Attribut nature for choice list (dropdown). Backend stores value in agl_val_txtcourt from attribut_choix.agc_valeur. */
export const ATTRIBUT_NATURE_CHOICE = 'CHOICE'

/** Attribut nature for numeric values. Backend may use NUM or NUMERIC. */
export const ATTRIBUT_NATURE_NUMERIC = 'NUMERIC'

/** Attribut nature for text values. Backend may use TXT or TEXT. */
export const ATTRIBUT_NATURE_TEXT = 'TEXT'

export interface Attribut extends SymfonyRelation {
  atgId: number
  atgRefCode: string
  atgTitre: string
  /** Titre anglais (atg_titre_en), absent tant qu'il n'est pas saisi. Voir libelleDynamique. */
  atgTitreEn?: string | null
  atgNature: string
  atgStatut: string
  atgDescription?: string
  atgObligatoire?: boolean
  createdAt?: string
  updatedAt?: string
  atgKind: string
  atgCode: string
  /** MDI icon name from API (e.g. "mdi:road-variant"), same convention as Domaine.domaineIcon. Null/absent for the 35 pre-existing geometry-computed indicateurs and for normal attributs. */
  atgIcon?: string
  atgGeographicScope?: string
  /** MapLibre style JSON (version 8) when stored in DB for admin-created indicators */
  atgStyleJson?: Record<string, unknown> | null
  /** Preset id for indicators (atgKind === 'I'). API may return fk_indicateur_preset_id. */
  fkIndicateurPresetId?: number | null
  /** Geometry target for buffer indicators (infra): atout | contrainte. API may return atg_geom_target. */
  atgGeomTarget?: string | null
  /** Category reference code for atout/contrainte (e.g. ATOUT_BUFFER_EAU). API may return atg_geom_cat_ref_code. */
  atgGeomCatRefCode?: string | null
  /**
   * Direct sous-domaine link (replaces the old attribut -> competence_attribut -> competence -> sousdomaine
   * chain for indicateurs). Populated only for the 53 indicateurs of the PCD classification file; null for
   * every other attribut (the pre-existing geometry-computed indicateurs and non-indicateur attributs).
   * API may return fk_sousdomaine_id.
   */
  fkSousdomaineId?: number | null
  /**
   * Active choices for CHOICE-nature attributs, embedded by
   * GET /api/competence_type_ouvrage_attributs (avoids one GET /api/attribut_choixes
   * round-trip per attribut). Absent/empty for non-CHOICE attributs.
   */
  choices?: Array<{
    agcRefCode: string
    agcValeur: string
    agcValeurEn?: string | null
    agcOrdre: number
  }>
}
